import React, { useState } from 'react';
import OrganizationLayout from '../../components/organization/OrganizationLayout';

// Shadcn Components
import { Skeleton } from "../../components/ui/skeleton";
import { Alert, AlertDescription } from "../../components/ui/alert";

// Hooks
import { useOrganization } from '../../services/organization/getOrganizationDetails';
import { useStripeConnect } from "../../hooks/common/useStripeConnect";

// Stripe Components
import { 
    ConnectComponentsProvider,
    ConnectNotificationBanner,
    ConnectAccountManagement,
    ConnectPayouts,
    ConnectPayments,
    ConnectBalances,
    ConnectDocuments
} from '@stripe/react-connect-js';

const OrganizationFinances: React.FC = () => {
    const [loading, setLoading] = useState(false); // true later when there's loading components
    const [error, setError] = useState<string | null>(null);
    
    // Get current organization data and stripe connect instance
    const { organization, loading: orgLoading, error: orgError } = useOrganization();
    const stripeConnectInstance = useStripeConnect(organization?.stripe_account_id);

    if (loading || orgLoading) return (
        <OrganizationLayout>
            <div className="space-y-6">
                <div className="space-y-4">
                    <Skeleton className="h-8 w-[200px]" />
                    <div className="grid gap-4">
                        <Skeleton className="h-12 w-full" />
                        <Skeleton className="h-12 w-full" />
                        <Skeleton className="h-12 w-full" />
                    </div>
                </div>
            </div>
        </OrganizationLayout>
    );

    if (error || orgError) return (
        <OrganizationLayout>
            <Alert variant="destructive">
                <AlertDescription>{error || orgError?.message}</AlertDescription>
            </Alert>
        </OrganizationLayout>
    );

    return (
        <OrganizationLayout>
            <div className="space-y-6 sm:pb-0 pb-8 mb-6 md:mb-12">
                <h2 className="text-3xl font-bold tracking-tight">Finances</h2>
                
                {/* Stripe Connect Notification Banner */}
                {organization?.stripe_account_id && stripeConnectInstance && (
                    <ConnectComponentsProvider connectInstance={stripeConnectInstance}>
                        <ConnectNotificationBanner/>
                        <h2 className="text-xl font-bold tracking-tight">Account Management</h2>
                        <ConnectAccountManagement />
                        <h2 className="text-xl font-bold tracking-tight">Payouts</h2>
                        <ConnectPayouts />
                        <h2 className="text-xl font-bold tracking-tight">Payments</h2>
                        <ConnectPayments />
                        <h2 className="text-xl font-bold tracking-tight">Balances</h2>
                        <ConnectBalances />
                        <h2 className="text-xl font-bold tracking-tight">Documents</h2>
                        <ConnectDocuments />
                    </ConnectComponentsProvider>
                )}
                
            </div>
        </OrganizationLayout>
    );
};

export default OrganizationFinances;